import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PoliticasPrivacidad from './pages/PoliticasPrivacidad';
import TerminosCondiciones from './pages/TerminosCondiciones';
import EliminacionDatos from './pages/EliminacionDatos';
import MiRifa from './pages/MiRifa';
import { AlertaProvider } from './context/AlertaContext';

const App = () => {
  return (
    <AlertaProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/politicas-privacidad" element={<PoliticasPrivacidad />} />
          <Route path="/terminos-y-condiciones" element={<TerminosCondiciones />} />
          <Route path="/eliminacion-de-datos" element={<EliminacionDatos />} />
          <Route path="/:id" element={<MiRifa />} />
        </Routes>
        <Footer />
      </Router>
    </AlertaProvider>
  );
};

export default App;
